<template>
  <div>
    <h1 class="text-h4 mb-4">Neuen Benutzer einladen</h1>

    <v-form method="post" :action="pageProps.form.action">
      <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">

      <v-card class="mb-4">
        <v-card-text>
          <v-text-field label="Email" name="user[email]" :model-value="pageProps.user.email" />
          <p class="text-body-2 text-medium-emphasis">
            Es wird eine E-Mail mit Anweisungen zur Einrichtung des neuen Kontos an den eingeladenen Benutzer geschickt.
          </p>
        </v-card-text>
      </v-card>

      <v-btn color="primary" type="submit">Benutzer einladen</v-btn>
    </v-form>
  </div>
</template>

<script setup>
defineProps({
  pageProps: {
    type: Object,
    required: true,
  },
});
</script>
